export const TWCTimeLogoIDs = {
  logoAndTimeWidgetLogo: 'my_weather_page_logo_and_time_widget_logo',
  logoAndTimeWidgetTime: 'my_weather_page_logo_and_time_widget_time',
};
